import { Show } from "solid-js";

export const BackButton = (props) => {
  const onClickHandler = props.onClickHandler;
  const className = props.className;

  return (
    <button 
      class={`font-bold uppercase ${className != undefined ? className : ''}`}
      onClick={onClickHandler != undefined ? onClickHandler : null}
    >
      <Show
        when={props.children}
        fallback={(<span><svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 -960 960 960" class="inline-block" width="32"><path fill="currentColor" d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/></svg></span>)}
      >
        {props.children}
        
      </Show>
    </button>
  )
}
